module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_4.96aefca3.png";